import "@/App.css";
import { ReactLenis } from "lenis/react";
import KohinoorLanding from "@/pages/KohinoorLanding";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App" data-testid="app-root">
        <KohinoorLanding />
      </div>
    </ReactLenis>
  );
}

export default App;
